<!-- 标定输入组件 -->
<template>
  <div class="single-bind-group">
    <div
        :key="singleBindIndex"
        @click="clickSingleBindCmp(singleBindIndex)"
        @dragover="allowSingleBind"
        @drop="(event) => dragToSingleBindCmp(event, singleBindItem, singleBindIndex)"
        class="single-bind">
      <div class="cmp-handle">
        <el-dropdown>
          <span class="el-dropdown-link">
            <i class="el-input__icon el-icon-more"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
                :disabled="startStatus.hasStart === true"
                @click.native="handleCmp('delete', singleBindItem, singleBindIndex)">删除
            </el-dropdown-item>
            <el-dropdown-item
                :disabled="startStatus.hasStart === true"
                @click.native="setStep('delete', singleBindItem, singleBindIndex)">设置step
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!--{{ 'canStatus->'+canStatus }}-->
      <el-input v-model="singleBindItem.name" placeholder="请输入内容" class="title" @change="saveAllCpt"
                :disabled="getCurCmpStatus"></el-input>
<!--      <el-button @click="bindTest">测试</el-button>-->
      <br>
      <el-button-group class="margin-top6">
        <el-button
            :class="projectStatus? 'actived' : ''"
            disabled
            size="small">
          工作页
        </el-button>
        <el-button
            :class="!projectStatus ? 'actived' : ''"
            disabled
            size="small">
          参考页
        </el-button>
      </el-button-group>
      <a>
        <el-table :data="singleBindItem.dataSources" border class="table">
          <el-table-column
              align="center"
              label="标定量名称"
              min-width="100"
              prop="text">
            <template slot-scope="scope">
            <span :title="scope.row.text"
                  @dblclick="(event)=>dbClick(event,scope.row.key)"
                  style="white-space: nowrap;cursor: pointer">{{scope.row.text}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center"
                           label="值"
                           min-width="50"
                           prop="value">
            <template slot-scope="scope">
              <el-button @click="showTable(scope.row.key)" type="text"
                         v-if="getCharacteristicNodes(scope.row.key)!==null">
                查看表格
              </el-button>
              <!--              <el-button @click="tableCalibration=true" type="text"-->
              <!--                         v-if="getCharacteristicNodes(scope.row.key)!==null">-->
              <!--                查看表格-->
              <!--              </el-button>-->
              <el-input-number
                  :disabled="!projectStatus"
                  :max="getMax(scope.row.key)"
                  :min="getMin(scope.row.key)"
                  :step="scope.row.step"
                  @change="handleChange(singleBindItem.cid, scope.row.key, scope.row.value)"
                  @click="(event)=>toEdit(event)"
                  controls-position="right"
                  size="small"
                  v-else
                  v-model="scope.row.value">
              </el-input-number>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="操作"
              min-width="20">
            <template slot-scope="scope">
              <el-button @click="deleteDataSourceItem(scope.row)" icon="el-icon-delete" style="color: #222222"
                         type="text"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </a>
    </div>
    <el-dialog :append-to-body="true"
               :title="'设置步幅'"
               :visible.sync="setStepCtr"
               top="30vh"
               width="800px">
      <el-table
          :data="stepList"
          max-height="400"
          style="width: 100%">
        <el-table-column
            label="标定量名称"
            prop="text"
            width="350">
        </el-table-column>
        <el-table-column
            label="步幅"
            prop="value"
            width="400">
          <template slot-scope="scope">
            <el-input-number :max="10" :min="0" label="步幅" v-model="scope.row.value"></el-input-number>
          </template>
        </el-table-column>
      </el-table>
      <div class="dialog-footer" slot="footer">
        <el-button @click="cancleSet">取 消</el-button>
        <el-button @click="confirmSet(singleBindIndex)" type="primary">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :append-to-body="true"
               :visible.sync="tableCalibration"
               title="表格量标定"
               top="30vh"
               width="1300px"
               @opened="initChart">
      <!--      <el-table-->
      <!--        :data="tableCalibrationData"-->
      <!--        max-height="400"-->
      <!--        style="width: 100%">-->
      <!--        <el-table-column-->
      <!--            align="center"-->
      <!--            label="标定量名称"-->
      <!--            min-width="100"-->
      <!--            prop="text">-->
      <!--        </el-table-column>-->
      <!--        <el-table-column-->
      <!--            align="center"-->
      <!--            label="值"-->
      <!--            min-width="50"-->
      <!--            prop="value">-->
      <!--          <template slot-scope="scope">-->
      <!--            <el-input-number-->
      <!--              :disabled="!panelStatus"-->
      <!--              :max="scope.row.upperLimit"-->
      <!--              :min="scope.row.lowerLimit"-->
      <!--              :step="scope.row.step"-->
      <!--              @change="handleChange(singleBindItem.cid, scope.row.id, scope.row.value)"-->
      <!--              @click="(event)=>toEdit(event)"-->
      <!--              controls-position="right"-->
      <!--              size="small"-->
      <!--              v-model="scope.row.value">-->
      <!--            </el-input-number>-->
      <!--          </template>-->
      <!--        </el-table-column>-->
      <!--        <el-table-column-->
      <!--          align="center"-->
      <!--          label="步幅"-->
      <!--          min-width="50"-->
      <!--          prop="step">-->
      <!--          <template slot-scope="scope">-->
      <!--            <el-input-number :max="10" :min="0" label="步幅" size="mini" v-model="scope.row.step"></el-input-number>-->
      <!--          </template>-->
      <!--        </el-table-column>-->
      <!--      </el-table>-->

      <!--      以下为测试代码-->
      <el-card shadow="never">
        <div ref="chart" style="width:600px;height:410px;float: left"></div>
        <div>
          <el-table
              :data="data.x"
              border
              style="width:600px;float: right;margin-top: 10px;margin-bottom: 10px"
              :cell-class-name="firstCol"
              :header-cell-style="{background:'#F5F7FA'}">
            <el-table-column
                align="center"
                label=" X \ Y ">
              <template slot-scope="scope">
                <el-input v-model="scope.row.x"></el-input>
              </template>
            </el-table-column>
            <el-table-column
                class-name="ts"
                align="center"
                v-for="(item,index) in data.y"
                :key="index"
                :index="index">
              <template slot="header" slot-scope="scope">
                <el-input v-model="data.y[index]"></el-input>
              </template>
              <template slot-scope="scope">
                <el-input v-model="data.z[scope.$index][index]"
                          @input="change(scope.$index,index)"
                          @focus="emphasis(scope.$index,index)"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
      <!--      以上为测试代码-->

      <div class="dialog-footer" slot="footer">
        <el-button @click="clearTableInfo" type="primary">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import echarts from 'echarts';
import 'echarts-gl';
import projectDetailAPI from '@/api/projectDetail';
// 测试用↑

export default {
  props: {
    singleBindIndex: {
      type: Number,
    },
    singleBindItem: {
      type: Object,
    },
    startStatus: {
      type: Object,
    },
  },
  data() {
    return {
      // 设置step数据列表
      stepList: [],
      setStepCtr: false,
      tableCalibration: false,
      hoverClass: '',
      signalForm: {},
      tableCalibrationData: [],

      // 以下为测试变量
      chart: {},
      data: {
        x: [
          { x: '1' },
          { x: '2' },
          { x: '3' },
          { x: '4' },
          { x: '5' },
        ],
        y: ['3', '6', '9', '12', '15'],
        z: [
          ['1', '11', '21', '31', '41'],
          ['3', '13', '23', '33', '43'],
          ['5', '15', '25', '35', '45'],
          ['7', '17', '27', '37', '47'],
          ['9', '19', '29', '39', '49'],
        ],
      },
    };
  },
  watch: {
    projectStatus() {
      if (this.projectStatus === true) {
        this.setInitValues();
      }
    },
    bindIniKey() {
      this.setInitValues();
    },
    // 表格实时更新
    chartData() {
      // 为解决最后一行数据显示bug，高亮前清除表格
      this.chart = echarts.init(this.$refs.chart);
      this.chart.clear();
      this.initChart();
    },
  },
  mounted() {
    // setTimeout(() => {
    //   this.setInitValues();
    // }, 3000);
    // this.setInitValues();
  },
  computed: {
    ...mapState('Engineering', [
      'singleBindValue',
      'componentStyleInfoArray',
      'leftStructure',
      'dragTreeNodeType',
      'singleBindStatus',
      'treeDatabase',
      'canPageStates',
    ]),
    ...mapGetters('Engineering', ['activedPanelData', 'getCurCmpStatus', 'getInitValues']),
    canStatus() {
      const self = this;
      const dataSources = self.singleBindItem.dataSources;
      if (dataSources.length > 0) {
        const key = dataSources[0].key;
        const mIndex = key.indexOf(':') + 1;
        const dIndex = key.indexOf('.');
        const canId = key.slice(mIndex, dIndex);
        if (this.canPageStates[canId]) {
          console.log('this.treeDatabase[canId].status', this.canPageStates[canId].status);
          return this.canPageStates[canId].status || false;
        }
      }
      return false;
    },
    // 当前面板状态
    panelStatus() {
      return this.$store.state.Engineering.curPanelStatus;
    },
    // 当前项目状态
    projectStatus() {
      return this.$store.state.Engineering.curProjectStatus;
    },
    //
    bindIniKey() {
      return this.$store.state.Engineering.bindIniKey;
    },
    // 表格标定折线图数据
    chartData() {
      let unit = [];
      const chartData = [];
      const { data } = this;
      for (let i1 = 0; i1 < data.x.length; i1++) {
        for (let i2 = 0; i2 < data.y.length; i2++) {
          unit.push([data.x[i1].x, data.y[i2], data.z[i1][i2]]);
        }
        chartData.push(unit);
        unit = [];
      }
      for (let i3 = 0; i3 < data.y.length; i3++) {
        for (let i4 = 0; i4 < data.x.length; i4++) {
          unit.push([data.x[i4].x, data.y[i3], data.z[i4][i3]]);
        }
        chartData.push(unit);
        unit = [];
      }
      return chartData;
    },
    // 表格设定
    option() {
      const option = {
        grid3D: {},
        xAxis3D: {},
        yAxis3D: {},
        zAxis3D: {},
        series: [],
      };
      for (let i = 0; i < this.chartData.length; i++) {
        const data = {};
        data.type = 'line3D';
        data.data = this.chartData[i];
        option.series.push(data);
      }
      return option;
    },
  },
  methods: {
    ...mapMutations('Engineering', [
      'clickComponent',
      'addSignaToSingleCmp',
      'deleteComponent',
      'deleteDataSource',
      'setAnchorPointId',
      'setSingleBindStep',
      'setAnchorKeyWord']),
    ...mapActions('Engineering', ['setBindValue', 'deleteCpt', 'saveAllCpt']),
    toEdit(event) {
      event.stopPropagation();
    },
    dbClick(event, key) {
      event.stopPropagation();
      const arr = key.split('.');
      const str = arr.join('');
      const arr2 = str.split(':');
      const str2 = arr2.join('');
      this.setAnchorKeyWord(key.substring(key.lastIndexOf('.') + 1)); // 信号名
      setTimeout(() => {
        this.setAnchorKeyWord('');
        this.setAnchorPointId('');
        setTimeout(() => {
          this.setAnchorPointId(str2);
        }, 50);
      }, 50);
    },
    // 设置步幅
    setStep() {
      console.log(this.singleBindItem);
      const { steps = [], dataSources = [] } = this.singleBindItem;
      this.stepList = dataSources.map((item, index) => ({
        text: item.text,
        value: steps[index] || 0,
      }));
      this.setStepCtr = true;
    },
    cancleSet() {
      this.setStepCtr = false;
    },
    confirmSet(index) {
      const stepList = this.stepList.map(item => item.value);
      this.setSingleBindStep({ singIndex: index, stepList });
      if (this.saveAllCpt()) {
        this.setStepCtr = false;
        this.$message({
          message: '保存成功',
          type: 'success',
        });
      }
    },
    deleteDataSourceItem(rowData) {
      console.log(rowData);
      const { singleBindIndex } = this;
      this.$store.commit('Engineering/deleteDataSource', {
        cptIndex: singleBindIndex,
        dataSourceKey: rowData.key,
      });
    },
    // 拖入标定量
    dragToSingleBindCmp(event, item, componentIndex) {
      // 如果面板正在运行则无法添加
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      const dragNode = JSON.parse(event.dataTransfer.getData('dragNodeData'));
      const { id } = dragNode;
      // 判断当前dataSources中是不是已经有了;
      if (this.singleBindItem.dataSources.findIndex(item2 => item2.key === id) > -1) {
        this.$message({
          message: '数据源已经存在',
        });
        return;
      }
      // if (this.singleBindItem.dataSources.length > 0) {
      //   const key = this.singleBindItem.dataSources[0].key;
      //   console.log(key, id);
      //   const mIndex = key.indexOf(':');
      //   const dIndex = key.indexOf('.');
      //   const str = key.slice(mIndex, dIndex);
      //   if (id.indexOf(str) < 0) {
      //     this.$message({
      //       message: '该组件不支持多通道下的标定量',
      //     });
      //     return;
      //   }
      // }
      console.log('dragNode1', dragNode);
      this.addSignaToSingleCmp({ dragNode, componentIndex });
    },
    allowSingleBind(event) {
      event.preventDefault();
      if (this.dragTreeNodeType === 12) {
        event.dataTransfer.dropEffect = 'copy';
      } else {
        event.dataTransfer.dropEffect = 'none';
      }
    },
    clickSingleBindCmp(index) {
      this.clickComponent({ componentName: 'singleBind', cmpIndex: index, cmpType: 'singleBind' });
    },
    handleChange(componentId, key, value) {
      console.log(componentId, key, value);
      this.setBindValue({
        datasource: key,
        componentId,
        value,
      }).then((res) => {
        if (res) {
          this.$message({
            showClose: true,
            message: '设置成功！',
            type: 'success',
          });
        } else {
          this.$message({
            showClose: true,
            message: '设置失败',
            type: 'warning',
          });
        }
      });
    },
    handleCmp(command, component, index) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      switch (command) {
        case 'delete':
          this.deleteCpt({
            index,
          });
          break;
        default:
          break;
      }
    },
    // 得到下限
    getMin(dataSourceKey) {
      return this.treeDatabase[dataSourceKey].lowerLimit;
    },
    // 得到上限
    getMax(dataSourceKey) {
      return this.treeDatabase[dataSourceKey].upperLimit;
    },
    getCharacteristicNodes(dataSourceKey) {
      if (!this.treeDatabase[dataSourceKey]) {
        return null;
      }
      return this.treeDatabase[dataSourceKey].characteristicNodes;
    },
    setInitValues() {
      if (!this.getInitValues) {
        console.log('推出了！！');
        return;
      }
      console.log('标定初始化！！！！！');
      const m = new Map();
      // this.getInitValues.map((item) => {
      //   m.set(item.key, item.value);
      // });
      // this.singleBindItem.dataSources.map((item) => {
      //   item.value = !m.get(item.key) ? null : m.get(item.key);
      // });
      this.getInitValues.map((item) => {
        m.set(item.id, item.value);
      });
      console.log(m);
      this.singleBindItem.dataSources.map((item) => {
        item.value = !m.get(item.key) ? null : m.get(item.key);
        console.log(item.key);
        console.log(item.value);
      });
    },
    setTableInitValues() {
      const m = new Map();
      this.getInitValues.map((item) => {
        m.set(item.key, item.value);
      });
      this.tableCalibrationData.map((item) => {
        item.value = !m.get(item.id) ? null : m.get(item.id);
      });
    },
    showTable(dataSourceKey) {
      this.tableCalibrationData = [];
      this.tableCalibration = true;
      if (this.getCharacteristicNodes(dataSourceKey) !== null) {
        this.getCharacteristicNodes(dataSourceKey).map((col) => {
          col.map((row) => {
            row.step = 1;
            this.tableCalibrationData.push(row);
          });
        });
      }
      this.setTableInitValues();
    },
    clearTableInfo() {
      this.tableCalibration = false;
    },
    // 初始化表格
    initChart() {
      this.chart = echarts.init(this.$refs.chart);
      this.chart.setOption(this.option);
    },
    // 表格标定样式回调方法
    firstCol({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return 'firstCol';
      }
      return '';
    },
    // 高亮选中点
    emphasis(row, col) {
      this.chart = echarts.init(this.$refs.chart);
      this.chart.clear();
      const emphasisPoint = {
        grid3D: {},
        xAxis3D: {},
        yAxis3D: {},
        zAxis3D: {},
        series: [],
      };
      const point = this.data;
      const data = {};
      data.type = 'scatter3D';
      data.data = [[point.x[row].x, point.y[col], point.z[row][col]]];
      data.symbolSize = 15;
      data.color = 'red';
      emphasisPoint.series.push(data);
      this.option.series.map((item) => {
        emphasisPoint.series.push(item);
      });
      this.chart.setOption(emphasisPoint);
    },
    change(row, col) {
      console.log(`row:${row} col:${col}`);
    },
    bindTest() {
      const projectId = this.$store.state.Engineering.projectId;
      projectDetailAPI.bindTest(projectId);
      // projectDetailAPI.getBindIni(projectId);
    },
  },
};
</script>

<style lang="scss">
  @import "../../style/mixin";

  .firstCol {
    background: #F5F7FA;
  }

  .el-table__header th.ts div {
    padding-left: 5px;
    padding-right: 5px;
  }

  .title {
    font-size: 14px;
    font-weight: bold;
    width: 50%;
    margin-bottom: 10px;
  }

  .single-bind-group {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;

    .single-bind {
      border: dashed 1px #eee;
      width: 100%;
      height: 100%;
      padding: 10px;
      position: relative;
      overflow: hidden !important;

      .cmp-handle {
        position: absolute;
        top: 0;
        right: 0;

        .el-input__icon {
          line-height: 25px;
        }
      }

      .table {
        width: 100%;
        height: 80%;
        overflow: auto;
        @include hide-scroll-bar;
      }

      // 去除多余的横线
      .el-table::before {
        height: 0;
      }

      &:hover {
        animation: 1s shadowChange infinite;
      }

      @keyframes shadowChange {
        0% {
          box-shadow: 0 0 2px #eee;
        }
        50% {
          box-shadow: 0 0 2px #aaa;
        }
        100% {
          box-shadow: 0 0 2px #eee;
        }
      }

      .margin-top6 {
        margin-top: 6px;

        .el-input-number.is-controls-right {
          .el-input__inner {
            padding-left: 0px;
            padding-right: 30px;
            width: 100px;
          }
        }
      }

      .title {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 10px;
      }

      .el-button {
        &.actived {
          background-color: #409EFF;
          color: #fff;
        }
      }

      .value {
        display: flex;
        min-height: 32px;
        flex-direction: row;
        align-items: center;

        .label {
          font-size: 12px;
          padding-right: 5px;

          .el-input {
            width: 60px;
          }
        }

        .direction-icon {
          margin-left: 10px;

          &.red {
            color: #f00;
          }

          &.green {
            color: #0f0;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/engineering/SingleBind.vue